import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Alert } from 'src/app/interfaces/alert';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthManagerService, PassUpdateWithToken } from 'src/app/services/auth-manager/auth-manager.service';
import { UAParser } from 'ua-parser-js';
import { isPlatformBrowser } from '@angular/common';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrls: ['./set-new-password.component.scss']
})
export class SetNewPasswordComponent implements OnInit {
  loading = false;
  alert: Alert = null;
  errorStrings = ErrorStrings;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;
  parser = new UAParser();
  isBrowser: boolean;
  useRebrandedLayout: boolean;

  model: PassUpdateWithToken = {
    password: '',
    token: ''
  };

  constructor(
    public authManager: AuthManagerService,
    private router: Router,
    private route: ActivatedRoute,
    private featureFlagService: FeatureFlagsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  setPassword() {
    this.closeAlert();
    this.loading = true;
    this.authManager.setPasswordWithToken(this.model)
      .subscribe(
        () => {
          this.alert = {
            type: 'success',
            message: 'Your password has been updated.'
          };
          this.router.navigate(['/login']);
        },
        err => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            if (err.error && err.error.error_code === 'invalid_data') {
              this.alert = {
                type: 'danger',
                message: Array.isArray(err.error?.detail)
                ? err.error.detail.join(', ')
                : err.error?.detail ?? 'An unexpected error occurred.'
              };
            if (err.error && err.error.error_code === 'weak_password') {
              this.alert = {
                type: 'danger',
                message: err.error.error_message ?? 'Your password is too simple. Please use a mix of uppercase and lowercase letters, numbers, and special characters.'
              };
            }
            } else {
              this.alert = {
                type: 'danger',
                message: Array.isArray(err.error?.detail)
                ? err.error.detail.join(', ')
                : err.error?.detail ?? 'An unexpected error occurred.'
              };
            }
          } else {
            this.alert = {
              type: 'danger',
              message: Array.isArray(err.error?.detail)
              ? err.error.detail.join(', ')
              : err.error?.detail ?? 'An unexpected error occurred.'
            };
          }
        }
      )
      .add(() => {
        this.loading = false;
      });
  }

  closeAlert() {
    this.alert = null;
  }

  ngOnInit(): void {
    const oSCheck = this.parser.getOS();
    this.model.token = this.route.snapshot.paramMap.get('token');
    if (oSCheck.name === "iOS") {
      const redirectTo = 'uk.co.identibase://reset-password';
      const parameterName = 'token';
      const parameterValue = this.model.token;
      if (this.isBrowser) {
        window.location.href = `${redirectTo}?${parameterName}=${parameterValue}`;
      }
    }
  }
}
